"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseIcon = exports.ClickableIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Button = require("../Button");
var _Text = require("../Text");
var _ = require("./");
var _ClickableIconModule = _interopRequireDefault(require("./ClickableIcon.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ClickableIcon = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    size = 'medium',
    ariaLabel,
    onClick,
    className,
    // Deprecated for Clickable Icon
    classNames,
    ...props
  } = _ref;
  const onKeyDownHandler = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onClick && onClick(e);
    }
  };
  return /*#__PURE__*/React.createElement(_Button.UnstyledButton, _extends({}, props, {
    onClick: onClick,
    onKeyDown: onKeyDownHandler,
    ariaLabel: ariaLabel,
    className: (0, _classify.default)(_ClickableIconModule.default.button, {
      [_ClickableIconModule.default.small]: size === 'small',
      [_ClickableIconModule.default.medium]: size === 'medium',
      [_ClickableIconModule.default.large]: size === 'large'
    }, classNames?.button),
    ref: ref
  }), /*#__PURE__*/React.createElement(_.Icon, _extends({
    size: size,
    className: classNames?.icon || className
  }, props)));
});
exports.ClickableIcon = ClickableIcon;
const CloseIcon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    size = 'medium',
    type = 'regular',
    color = _Text.TEXT_COLORS.primary,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(ClickableIcon, _extends({
    name: "close",
    size: size,
    type: type,
    color: color
  }, props, {
    ref: ref
  }));
});
exports.CloseIcon = CloseIcon;